// src/pages/Home.jsx
import React, { useEffect } from 'react';

import Hero from '../components/hero/Hero';
import AboutSection from '../components/about/AboutSection';
import SectionTitle from '../components/common/SectionTitle';
import ServiceCard from '../components/services/ServiceCard';
import TestimonialSlider from '../components/testimonials/TestimonialSlider';
import AppointmentForm from '../components/appointment/AppointmentForm';
import services from '../data/services';
import DoctorImage from '../Assets/TeamandOthers/sridhar_reddyimg.png'
import DoctorbgImage from '../Assets/TeamandOthers/Sridharbg1.png'
import contactImage from '../Assets/TeamandOthers/Reception.webp'
import HorizontalCarousel from "../components/common/HorizontalCarousel";

import { Link } from 'react-router-dom';

const Home = () => {
  
  useEffect(() => {
  const cards = document.querySelectorAll(".founder-parallax-card");
  if (!cards.length) return;

  const range = 40;
  const calcValue = (pos, size) =>
    (pos / size) * range - range / 2;

  let rafId = null;

  const handleMouseMove = (e) => {
    if (rafId) cancelAnimationFrame(rafId);

    rafId = requestAnimationFrame(() => {
      const xValue = calcValue(e.clientX, window.innerWidth);
      const yValue = calcValue(e.clientY, window.innerHeight);

      cards.forEach((card) => {
        // Card tilt
        card.style.transform = `
          rotateX(${yValue}deg)
          rotateY(${xValue}deg)
        `;

        // Foreground image depth
        const img = card.querySelector(".founder-parallax-card__img");
        if (img) {
          img.style.transform = `
            translateX(${-xValue * 1.5}px)
            translateY(${yValue * 1.5}px)
            translateZ(80px)
          `;
        }

        // Background drift
        const bg = card.querySelector(".founder-parallax-card__bg");
        if (bg) {
          bg.style.backgroundPosition = `
            ${xValue * 0.45}px
            ${-yValue * 0.45}px
          `;
        }
      });
    });
  };

  const reset = () => {
    cards.forEach((card) => {
      card.style.transform = "rotateX(0deg) rotateY(0deg)";

      const img = card.querySelector(".founder-parallax-card__img");
      if (img) {
        img.style.transform = "translateZ(0)";
      }
    });
  };

  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseleave", reset);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseleave", reset);
    if (rafId) cancelAnimationFrame(rafId);
  };
}, []);
  return (
    <main className="">
      <Hero />

      {/* Leadership Section - Acharya Dental style adaptation */}
       <section className="leaderSection bg-[#0d47a1] text-white py-16 md:py-16 overflow-hidden -mt-50">
  <div className="container mx-auto px-8">
    <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-16">

      {/* LEFT — Text */}
      <div className="md:w-1/2 text-center md:text-left flex flex-col items-center md:items-start">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Leadership
        </h2>

        <p className="text-xl md:text-2xl mb-8 max-w-xl opacity-90">
          Under the leadership of Dr. Arumalla Sridhar Reddy, a renowned Dental,
          Oral and Maxillofacial Surgeon
        </p>

        <div className="inline-block bg-white text-[#0d47a1] px-8 py-4 rounded-full text-2xl font-bold shadow-lg">
          30+ Years Experience
        </div>
      </div>

      {/* RIGHT — Parallax Doctor Card */}
      <div className="flex justify-center md:justify-start">
        <div className="text-center flex flex-col items-center">

          {/* Floating + Glow Wrapper */}
          <div className="relative animate-float-slow mb-6">

            {/* Glow */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/30 to-cyan-400/20 blur-3xl scale-110 -z-10"></div>

            {/* === PARALLAX CARD === */}
<div className="founder-parallax-card relative w-48 h-48 md:w-96 md:h-96 rounded-full overflow-hidden border-8 border-white shadow-2xl cursor-pointer">

              {/* Background layer */}
              <div
                className="founder-parallax-card__bg absolute inset-0"
                style={{
                  backgroundImage: `url(${DoctorbgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  // filter: 'brightness(0.6) blur(3px)',
                }}
              />

              {/* Foreground Image */}
              <img
                src={DoctorImage}
                alt="Dr. Arumalla Sridhar Reddy"
                className="founder-parallax-card__img w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Text Below Image */}
          <h3 className="text-xl md:text-2xl font-bold">
            Dr. Arumalla Sridhar Reddy
          </h3>

          <p className="text-blue-200 mt-1">
            BDS, MDS – Oral & Maxillofacial Surgeon
          </p>

          <p className="text-sm md:text-base mt-1 opacity-90">
            Founder & Chairman
          </p>
        </div>
      </div>
    </div>

    {/* Bottom Caption */}
    <div className="text-center mt-12 opacity-90 text-lg md:text-xl">
      Transforming smiles with precision, care and 30+ years of excellence
    </div>
  </div>
</section>


      <AboutSection />

      {/* Services Section – exact match to reference style */}
<section className="py-20 bg-gray-50">
  <div className="container mx-auto px-6">
    <div className="text-center mb-16">
            <span className="inline-block bg-white text-blue-600 px-6 py-2 rounded-full font-medium text-xl shadow-sm mb-6">
              Our Services
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Our dental clinic offers complete oral healthcare services including preventive, cosmetic, and restorative treatments using the latest dental technology.
            </p>
          </div>
   <HorizontalCarousel interval={3000}>
  {services.map((service, index) => (
    
    <div key={index} className="px-3 h-full"> 
      <div className="relative flex flex-col bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden h-full">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-[200px] object-cover"
        />
        <div className="p-6">
          <h3 className="text-xl font-bold mb-2">{service.title}</h3>
          <p className="text-gray-600 mb-4">{service.description}</p>
          <a href={service.link} className="text-blue-600 font-semibold hover:underline">
            Learn More →
          </a>
        </div>
      </div>
    </div>
  ))}
</HorizontalCarousel>
  </div>
</section>



         <section className="relative min-h-[620px] flex flex-col md:flex-row items-center bg-gray-900 overflow-hidden">
        <div
          aria-hidden="true"
          className="absolute right-0 top-0 h-full w-full md:w-3/5 bg-cover bg-right z-10"
          style={{
            backgroundImage: `url(${contactImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center right',
          }}
        />

        <div
          aria-hidden="true"
          className="skewBg absolute left-[-5%] top-0 h-full w-full md:w-[60%]  pointer-events-none overflow-hidden z-10 skew-x-0 md:-skew-x-12"
        >
          <div className="absolute left-0 top-0 h-full w-full skew-x-0 md:skew-x-12" style={{ transformOrigin: 'top left' }}>
            <div className="h-full bg-[#0d47a1] flex items-center px-6 ">
              <div className="skewSection max-w-2xl m-auto text-white pointer-events-auto flex flex-col justify-center">
                <p className="text-teal-200 uppercase tracking-wider font-medium mb-4">
                  The Best Services
                </p>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
                  Dedicated to Give You The Best Services
                </h1>
                <p className="text-base md:text-xl text-white/90 leading-relaxed mb-6">
                  We provide state-of-the-art dental care with precision, comfort, and compassion. Our team ensures each patient receives personalized treatments for a healthier, brighter smile.
                </p>
                <Link
                to='/contact'
                  type="button"
                  
                  // className=" items-center px-6 py-3 bg-white text-[#0d47a1] font-semibold text-base rounded-full transition-all duration-300 shadow-lg shadow-white/20 hover:-translate-y-1 active:translate-y-0 active:shadow-md"
                  className='skewContactbutton bg-white text-[#0d47a1] font-semibold text-base rounded-full w-[26%] px-6 py-3'
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute inset-0 bg-black/20 z-5" />
      </section>

      {/* Technology Section */}
     <section className="py-24 bg-gradient-to-b from-white to-gray-50">
  <div className="container mx-auto px-6">

    {/* Header */}
    <div className="text-center mb-20">
      <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-blue-50 text-blue-600 text-xl font-medium mb-6">
        <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
        Technology Driven Care
      </span>

      <SectionTitle title="Advanced Dental Technology" />

      <p className="mt-6 text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
        Precision dentistry powered by world-class digital systems,
        delivering faster, safer, and more comfortable treatments.
      </p>
    </div>

    {/* Cards */}
    <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">

      {/* Card */}
      <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">

        {/* Glow */}
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

        {/* Icon */}
        <div className="relative z-10 w-16 h-16 mb-8 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-400 text-white flex items-center justify-center text-2xl font-semibold shadow-lg">
          C
        </div>

        <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
          CEREC CAD/CAM
        </h3>

        <p className="relative z-10 text-gray-600 leading-relaxed">
          India’s first same-day crown technology delivering digitally designed,
          precision-milled restorations in a single visit.
        </p>
      </div>

      {/* Card */}
      <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">

        <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

        <div className="relative z-10 w-16 h-16 mb-8 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-400 text-white flex items-center justify-center text-2xl font-semibold shadow-lg">
          I
        </div>

        <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
          Digital Implants
        </h3>

        <p className="relative z-10 text-gray-600 leading-relaxed">
          Advanced implant systems combined with digital planning for higher
          accuracy, faster healing, and long-term success.
        </p>
      </div>

      {/* Card */}
      <div className="group relative p-10 rounded-3xl border border-white/60 bg-white/60 backdrop-blur-xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)] hover:shadow-[0_40px_80px_-20px_rgba(37,99,235,0.25)] transition-all duration-500 hover:-translate-y-3">

        <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-blue-500/10 to-transparent opacity-0 group-hover:opacity-100 transition"></div>

        <div className="relative z-10 w-16 h-16 mb-8 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-400 text-white flex items-center justify-center text-2xl font-semibold shadow-lg">
          L
        </div>

        <h3 className="relative z-10 text-2xl font-semibold text-gray-900 mb-4">
          Laser Dentistry
        </h3>

        <p className="relative z-10 text-gray-600 leading-relaxed">
          Minimally invasive laser treatments offering pain-free procedures,
          reduced bleeding, and quicker recovery times.
        </p>
      </div>

    </div>
  </div>
</section>


      <TestimonialSlider />
      <AppointmentForm />
    </main>
  );
};

export default Home;